import React, { useEffect, useRef } from 'react';
import './css/SpaceInvaders.css';
import snd1 from './assets/fastinvader1.wav';
import snd2 from './assets/fastinvader2.wav';
import snd3 from './assets/fastinvader3.wav';
import snd4 from './assets/fastinvader4.wav';

const CANVAS_WIDTH = 800;
const CANVAS_HEIGHT = 600;

// Authentic 13×8 pixel sprite of the 1978 Taito Space Invaders cannon
const CANNON_SPRITE = [
  [0,0,0,0,0,0,1,0,0,0,0,0,0],
  [0,0,0,0,0,1,1,1,0,0,0,0,0],
  [0,0,0,0,0,1,1,1,0,0,0,0,0],
  [0,1,1,1,1,1,1,1,1,1,1,1,0],
  [1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1],
];
const PIXEL_SCALE = 3; // scale each sprite pixel up by this many canvas pixels

// Authentic 22×16 pixel bunker sprite (Taito 1978)
const BASE_SPRITE = [
  [0,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0],
  [0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,1,1,1,1,1,1],
  [1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1,1],
  [1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1],
  [1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,1],
];
const BASE_SCALE = 3;
const BASE_W = 22;
const BASE_H = 16;

// Authentic Space Invaders top-row alien (squid) — 8×8 pixel, 2 animation frames
// Decoded from the original Taito 1978 ROM bytes:
// Frame A: 0x18,0x3C,0x7E,0xDB,0xFF,0x24,0x5A,0x81
// Frame B: 0x18,0x3C,0x7E,0xDB,0xFF,0xA5,0x42,0xA5
const SQUID_A = [
  [0,0,0,1,1,0,0,0],
  [0,0,1,1,1,1,0,0],
  [0,1,1,1,1,1,1,0],
  [1,1,0,1,1,0,1,1],
  [1,1,1,1,1,1,1,1],
  [0,0,1,0,0,1,0,0],
  [0,1,0,1,1,0,1,0],
  [1,0,0,0,0,0,0,1],
];
const SQUID_B = [
  [0,0,0,1,1,0,0,0],
  [0,0,1,1,1,1,0,0],
  [0,1,1,1,1,1,1,0],
  [1,1,0,1,1,0,1,1],
  [1,1,1,1,1,1,1,1],
  [1,0,1,0,0,1,0,1],
  [0,1,0,0,0,0,1,0],
  [1,0,1,0,0,1,0,1],
];

// Authentic Space Invaders 2nd-row alien (crab) — 11×8 pixel, 2 animation frames
// ROM bytes Frame A: 0x24,0x18,0x7E,0xD5,0xFF,0x6E,0x24,0x36 (11-bit wide)
// Frame A: claws raised outward  /  Frame B: claws tucked inward
const CRAB_A = [
  [0,0,1,0,0,0,0,0,1,0,0],
  [0,0,0,1,0,0,0,1,0,0,0],
  [0,0,1,1,1,1,1,1,1,0,0],
  [0,1,1,0,1,1,1,0,1,1,0],
  [1,1,1,1,1,1,1,1,1,1,1],
  [1,0,1,1,1,1,1,1,1,0,1],
  [1,0,1,0,0,0,0,0,1,0,1],
  [0,0,0,1,1,0,1,1,0,0,0],
];
const CRAB_B = [
  [0,0,1,0,0,0,0,0,1,0,0],
  [1,0,0,1,0,0,0,1,0,0,1],
  [1,0,1,1,1,1,1,1,1,0,1],
  [1,1,1,0,1,1,1,0,1,1,1],
  [1,1,1,1,1,1,1,1,1,1,1],
  [0,1,1,1,1,1,1,1,1,1,0],
  [0,0,1,0,0,0,0,0,1,0,0],
  [0,1,0,0,0,0,0,0,0,1,0],
];

// Authentic Space Invaders bottom-row alien (octopus) — 12×8 pixel, 2 animation frames
// Rows 4–5 in the formation, worth 10 points each
const OCTOPUS_A = [
  [0,0,1,1,1,1,1,1,1,1,0,0],
  [0,1,1,1,1,1,1,1,1,1,1,0],
  [1,1,0,1,1,0,0,1,1,0,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1],
  [0,1,0,1,1,1,1,1,1,0,1,0],
  [0,0,1,0,0,0,0,0,0,1,0,0],
  [0,1,0,1,0,0,0,0,1,0,1,0],
  [0,0,1,0,0,0,0,0,0,1,0,0],
];
const OCTOPUS_B = [
  [0,0,1,1,1,1,1,1,1,1,0,0],
  [0,1,1,1,1,1,1,1,1,1,1,0],
  [1,1,0,1,1,0,0,1,1,0,1,1],
  [1,1,1,1,1,1,1,1,1,1,1,1],
  [0,1,0,1,1,1,1,1,1,0,1,0],
  [0,0,1,1,0,0,0,0,1,1,0,0],
  [0,1,0,0,1,0,0,1,0,0,1,0],
  [0,0,1,0,0,0,0,0,0,1,0,0],
];

// Authentic invader death/explosion sprite (starburst, 8×8)
const EXPLOSION_SPRITE = [
  [0,1,0,0,0,0,1,0],
  [0,0,1,0,0,1,0,0],
  [1,1,0,1,1,0,1,1],
  [0,0,1,1,1,1,0,0],
  [0,0,1,1,1,1,0,0],
  [1,1,0,1,1,0,1,1],
  [0,0,1,0,0,1,0,0],
  [0,1,0,0,0,0,1,0],
];
const EXPLOSION_DURATION = 35; // frames the starburst sprite is shown

// Mystery saucer — 16×7 pixel, shown in the attract-screen score table
const MYSTERY_SPRITE = [
  [0,0,0,0,0,1,1,1,1,1,1,0,0,0,0,0],
  [0,0,0,1,1,1,1,1,1,1,1,1,1,0,0,0],
  [0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0],
  [0,1,1,0,1,1,0,1,1,0,1,1,0,1,1,0],
  [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
  [0,0,1,1,0,0,1,1,1,1,0,0,1,1,0,0],
  [0,0,0,1,1,0,0,0,0,0,0,1,1,0,0,0],
];

const ALIEN_SCALE = 3;
const ALIEN_COLS = 11;
const ALIEN_SPRITE_W = 8;
const ALIEN_SPRITE_H = 8;
const ALIEN_DRAW_W = ALIEN_SPRITE_W * ALIEN_SCALE;   // 24 px
const ALIEN_DRAW_H = ALIEN_SPRITE_H * ALIEN_SCALE;   // 24 px
const CRAB_SPRITE_W = 11;
const CRAB_DRAW_W = CRAB_SPRITE_W * ALIEN_SCALE;     // 33 px
const OCTOPUS_SPRITE_W = 12;
const OCTOPUS_DRAW_W = OCTOPUS_SPRITE_W * ALIEN_SCALE; // 36 px
const ALIEN_COL_SPACING = 16 * ALIEN_SCALE;           // 48 px — authentic left-edge-to-left-edge (16 orig px × 3)
const ROW_VERTICAL_SPACING = 16 * ALIEN_SCALE;        // 48 px — authentic row pitch (16 orig px × 3)
const ALIEN_FORMATION_W = (ALIEN_COLS - 1) * ALIEN_COL_SPACING + OCTOPUS_DRAW_W; // 516 px (widest row = octopus)

const SpaceInvaders = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    // ── Game state ─────────────────────────────────────────────────────────
    let gameState  = 'attract'; // 'attract' | 'playing'
    let credits    = 0;
    let blinkTimer = 0;
    let blinkOn    = true;

    // ── March sounds — 1→2→3→4→1→2… one per formation step ───────────────
    const marchSounds = [snd1, snd2, snd3, snd4].map(src => {
      const a = new Audio(src);
      a.preload = 'auto';
      return a;
    });
    let marchBeat = 0; // cycles 0‥3

    const keys = {
      left: false,
      right: false,
    };

    // 3 destructible bases — each pixel is individually tracked
    const baseXPositions = [150, 367, 584];
    const baseY = CANVAS_HEIGHT - 130;
    const bases = baseXPositions.map(bx => ({
      x: bx,
      y: baseY,
      pixels: BASE_SPRITE.map(row => [...row]), // mutable deep copy
    }));

    // Original only allows one player bullet on screen at a time
    const bullet = { active: false, x: 0, y: 0 };
    const BULLET_SPEED = 8;
    const BULLET_W = PIXEL_SCALE;
    const BULLET_H = PIXEL_SCALE * 4;

    // Score / lives — persisted across the useEffect closure via let
    let score    = 0;
    let hiScore  = 0;
    let lives    = 3;
    // Points per alien type, matching original (squid=30, crab=20, octopus=10)
    const POINTS = { squid: 30, crab: 20, octopus: 10 };

    const player = {
      x: CANVAS_WIDTH / 2 - (13 * PIXEL_SCALE) / 2,
      y: CANVAS_HEIGHT - 60,
      width: 13 * PIXEL_SCALE,
      height: 8 * PIXEL_SCALE,
      speed: 4,
    };

    // Top row of squid aliens — step-based horizontal movement + drop on boundary
    const ALIEN_STEP_X = 6;             // horizontal pixels per step (≈2 original pixels × scale)
    const ALIEN_STEP_Y = ALIEN_DRAW_H;  // drop one full sprite height when hitting a wall
    const ALIEN_LEFT_BOUND  = 20;
    const ALIEN_RIGHT_BOUND = CANVAS_WIDTH - 20;
    const topRow = {
      x: Math.floor((CANVAS_WIDTH - ALIEN_FORMATION_W) / 2),
      y: 80,   // pushed down to clear the HUD score bar
      dx: 1,           // 1 = moving right, -1 = moving left
      frame: 0,        // 0 = SQUID_A, 1 = SQUID_B; toggles every step
      stepTimer: 0,
      stepInterval: 20, // full grid starting speed — formula: 6 + (55/55)*14 = 20
      cells: Array.from({ length: ALIEN_COLS }, (_, i) => ({ col: i, alive: true })),
    };

    // Second row — crab aliens, shares x/frame/movement with topRow
    const middleRow = {
      cells: Array.from({ length: ALIEN_COLS }, (_, i) => ({ col: i, alive: true })),
    };

    // Third row — crabs (2nd crab row)
    const crabRow2 = {
      cells: Array.from({ length: ALIEN_COLS }, (_, i) => ({ col: i, alive: true })),
    };

    // Fourth row — octopus aliens
    const octopusRow1 = {
      cells: Array.from({ length: ALIEN_COLS }, (_, i) => ({ col: i, alive: true })),
    };

    // Fifth row — octopus aliens (bottom row, worth 10 pts, closest to player)
    const octopusRow2 = {
      cells: Array.from({ length: ALIEN_COLS }, (_, i) => ({ col: i, alive: true })),
    };

    // Active explosions — each has a static sprite timer + flying debris particles
    const explosions = [];

    const spawnExplosion = (ax, ay, spriteW = ALIEN_DRAW_W) => {
      const cx = ax + spriteW / 2;
      const cy = ay + ALIEN_DRAW_H / 2;
      const particles = [];

      // Debris spawned from each lit pixel of the explosion sprite (close-range)
      EXPLOSION_SPRITE.forEach((row, ri) => {
        row.forEach((px, ci) => {
          if (!px) return;
          const px_x = ax + ci * ALIEN_SCALE + ALIEN_SCALE / 2;
          const px_y = ay + ri * ALIEN_SCALE + ALIEN_SCALE / 2;
          const dx = px_x - cx;
          const dy = px_y - cy;
          const len = Math.sqrt(dx * dx + dy * dy) || 1;
          const speed = 1.5 + Math.random() * 2.5;
          const life = 50 + Math.floor(Math.random() * 30);
          particles.push({
            x: px_x, y: px_y,
            vx: (dx / len) * speed + (Math.random() - 0.5),
            vy: (dy / len) * speed + (Math.random() - 0.5),
            life, maxLife: life,
            size: 2,
          });
        });
      });

      // Far-reaching debris — random angles, higher speed, longer life
      for (let i = 0; i < 22; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = 3 + Math.random() * 5.5;
        const life  = 80 + Math.floor(Math.random() * 70);
        particles.push({
          x: cx + (Math.random() - 0.5) * ALIEN_DRAW_W,
          y: cy + (Math.random() - 0.5) * ALIEN_DRAW_H,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          life, maxLife: life,
          size: 1 + Math.floor(Math.random() * 2),
        });
      }

      explosions.push({ x: ax, y: ay, timer: EXPLOSION_DURATION, particles });
    };

    const handleKeyDown = (e) => {
      // Always suppress space-bar page scroll
      if (e.key === ' ') e.preventDefault();

      if (gameState === 'attract') {
        if (e.key === 'c' || e.key === 'C') {
          credits = Math.min(credits + 1, 99);
        }
        if ((e.key === 's' || e.key === 'S') && credits > 0) {
          credits--;
          gameState = 'playing';
        }
        return;
      }

      // Playing state
      if (e.key === 'ArrowLeft')  keys.left  = true;
      if (e.key === 'ArrowRight') keys.right = true;
      if (e.key === ' ') {
        if (!bullet.active) {
          bullet.active = true;
          bullet.x = player.x + Math.floor(player.width / 2) - Math.floor(BULLET_W / 2);
          bullet.y = player.y - BULLET_H;
        }
      }
    };

    const handleKeyUp = (e) => {
      if (e.key === 'ArrowLeft')  keys.left  = false;
      if (e.key === 'ArrowRight') keys.right = false;
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup',   handleKeyUp);

    const drawPlayer = () => {
      ctx.fillStyle = '#00FF41';
      CANNON_SPRITE.forEach((row, rowIdx) => {
        row.forEach((pixel, colIdx) => {
          if (pixel) {
            ctx.fillRect(
              player.x + colIdx * PIXEL_SCALE,
              player.y + rowIdx * PIXEL_SCALE,
              PIXEL_SCALE,
              PIXEL_SCALE
            );
          }
        });
      });
    };

    const drawBases = () => {
      ctx.fillStyle = '#00FF41';
      bases.forEach(base => {
        base.pixels.forEach((row, rowIdx) => {
          row.forEach((pixel, colIdx) => {
            if (pixel) {
              ctx.fillRect(
                base.x + colIdx * BASE_SCALE,
                base.y + rowIdx * BASE_SCALE,
                BASE_SCALE,
                BASE_SCALE
              );
            }
          });
        });
      });
    };

    const drawBullet = () => {
      if (!bullet.active) return;
      // Original bullet is a thin vertical bar drawn in white/green
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(bullet.x, bullet.y, BULLET_W, BULLET_H);
    };

    const drawExplosions = () => {
      explosions.forEach(exp => {
        // Static starburst sprite displayed for EXPLOSION_DURATION frames
        if (exp.timer > 0) {
          ctx.fillStyle = '#FFFFFF';
          EXPLOSION_SPRITE.forEach((row, ri) => {
            row.forEach((px, ci) => {
              if (px) {
                ctx.fillRect(
                  exp.x + ci * ALIEN_SCALE,
                  exp.y + ri * ALIEN_SCALE,
                  ALIEN_SCALE, ALIEN_SCALE
                );
              }
            });
          });
        }
        // Flying debris particles with alpha fade
        exp.particles.forEach(p => {
          if (p.life <= 0) return;
          ctx.globalAlpha = p.life / p.maxLife;
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(Math.round(p.x), Math.round(p.y), p.size, p.size);
        });
        ctx.globalAlpha = 1;
      });
    };

    // Render alien rows in white (authentic monochrome arcade colour)
    // Each sprite is centred within its column slot so all rows share the same visual axis.
    const drawAlienRow = (cells, y, spriteA, spriteB, spriteW) => {
      const sprite  = topRow.frame === 0 ? spriteA : spriteB;
      const xOffset = Math.floor((ALIEN_COL_SPACING - spriteW) / 2);
      ctx.fillStyle = '#FFFFFF';
      cells.forEach(cell => {
        if (!cell.alive) return;
        const ax = topRow.x + cell.col * ALIEN_COL_SPACING + xOffset;
        sprite.forEach((row, ri) => {
          row.forEach((px, ci) => {
            if (px) {
              ctx.fillRect(
                ax + ci * ALIEN_SCALE,
                y  + ri * ALIEN_SCALE,
                ALIEN_SCALE,
                ALIEN_SCALE
              );
            }
          });
        });
      });
    };

    const drawAliens = () => {
      const y0 = topRow.y;
      // Row 1 — squids
      drawAlienRow(topRow.cells,     y0,                          SQUID_A,   SQUID_B,   ALIEN_DRAW_W);
      // Rows 2–3 — crabs
      drawAlienRow(middleRow.cells,  y0 + ROW_VERTICAL_SPACING,   CRAB_A,    CRAB_B,    CRAB_DRAW_W);
      drawAlienRow(crabRow2.cells,   y0 + ROW_VERTICAL_SPACING*2, CRAB_A,    CRAB_B,    CRAB_DRAW_W);
      // Rows 4–5 — octopus
      drawAlienRow(octopusRow1.cells, y0 + ROW_VERTICAL_SPACING*3, OCTOPUS_A, OCTOPUS_B, OCTOPUS_DRAW_W);
      drawAlienRow(octopusRow2.cells, y0 + ROW_VERTICAL_SPACING*4, OCTOPUS_A, OCTOPUS_B, OCTOPUS_DRAW_W);
    };

    const update = () => {
      if (keys.left)  player.x = Math.max(0, player.x - player.speed);
      if (keys.right) player.x = Math.min(CANVAS_WIDTH - player.width, player.x + player.speed);

      if (bullet.active) {
        bullet.y -= BULLET_SPEED;
        if (bullet.y + BULLET_H < 0) {
          bullet.active = false;
        }

        // Bullet vs base collision — erode individual pixels
        if (bullet.active) {
          for (const base of bases) {
            const col = Math.floor((bullet.x + BULLET_W / 2 - base.x) / BASE_SCALE);
            if (col < 0 || col >= BASE_W) continue;
            const rowStart = Math.floor((bullet.y - base.y) / BASE_SCALE);
            const rowEnd   = Math.floor((bullet.y + BULLET_H - base.y) / BASE_SCALE);
            for (let row = rowStart; row <= rowEnd; row++) {
              if (row >= 0 && row < BASE_H && base.pixels[row][col]) {
                base.pixels[row][col] = 0;
                bullet.active = false;
                break;
              }
            }
            if (!bullet.active) break;
          }
        }
      }

      // Bullet vs alien collision — AABB per cell, bottom rows checked first (closest to player)
      if (bullet.active) {
        const y0 = topRow.y;
        const alienRows = [
          { cells: octopusRow2.cells,  y: y0 + ROW_VERTICAL_SPACING*4, w: OCTOPUS_DRAW_W, pts: POINTS.octopus },
          { cells: octopusRow1.cells,  y: y0 + ROW_VERTICAL_SPACING*3, w: OCTOPUS_DRAW_W, pts: POINTS.octopus },
          { cells: crabRow2.cells,     y: y0 + ROW_VERTICAL_SPACING*2, w: CRAB_DRAW_W,    pts: POINTS.crab    },
          { cells: middleRow.cells,    y: y0 + ROW_VERTICAL_SPACING,   w: CRAB_DRAW_W,    pts: POINTS.crab    },
          { cells: topRow.cells,       y: y0,                           w: ALIEN_DRAW_W,   pts: POINTS.squid   },
        ];
        outer: for (const row of alienRows) {
          const xOffset = Math.floor((ALIEN_COL_SPACING - row.w) / 2);
          for (const cell of row.cells) {
            if (!cell.alive) continue;
            const ax = topRow.x + cell.col * ALIEN_COL_SPACING + xOffset;
            const ay = row.y;
            if (
              bullet.x            < ax + row.w &&
              bullet.x + BULLET_W > ax &&
              bullet.y            < ay + ALIEN_DRAW_H &&
              bullet.y + BULLET_H > ay
            ) {
              cell.alive    = false;
              bullet.active = false;
              score += row.pts;
              if (score > hiScore) hiScore = score;
              spawnExplosion(ax, ay, row.w);
              break outer;
            }
          }
        }
      }

      // Move the top row of aliens on a step timer
      topRow.stepTimer++;
      if (topRow.stepTimer >= topRow.stepInterval) {
        topRow.stepTimer = 0;

        // ── Dynamic formation bounds — use live column extents ────────────
        // This fixes "ghost column" — the boundary shrinks as columns die.
        const allRowCells = [
          topRow.cells, middleRow.cells, crabRow2.cells,
          octopusRow1.cells, octopusRow2.cells,
        ];
        let minCol = ALIEN_COLS, maxCol = -1;
        for (const cells of allRowCells) {
          for (const cell of cells) {
            if (cell.alive) {
              if (cell.col < minCol) minCol = cell.col;
              if (cell.col > maxCol) maxCol = cell.col;
            }
          }
        }

        const nextX = topRow.x + topRow.dx * ALIEN_STEP_X;
        // Left/right pixel edges of surviving columns (use widest sprite for right edge)
        const liveLeft  = nextX + minCol * ALIEN_COL_SPACING;
        const liveRight = nextX + maxCol * ALIEN_COL_SPACING + OCTOPUS_DRAW_W;

        if (liveRight > ALIEN_RIGHT_BOUND || liveLeft < ALIEN_LEFT_BOUND) {
          // Hit a wall — drop down and reverse direction (authentic behaviour)
          topRow.y  += ALIEN_STEP_Y;
          topRow.dx  = -topRow.dx;
        } else {
          topRow.x = nextX;
        }
        // Toggle animation frame every step, matching the original arcade timing
        topRow.frame = 1 - topRow.frame;

        // ── March sound: play current beat then advance ───────────────────
        const snd = marchSounds[marchBeat];
        snd.currentTime = 0;
        snd.play().catch(() => {}); // ignore autoplay policy errors
        marchBeat = (marchBeat + 1) % 4;

        // ── Speed ramp: count surviving aliens and tighten the interval ───
        // Full grid (55) → 20 frames/step (original start speed)
        // Last alien (1) → 6 frames/step (fast)
        const totalAliens = 5 * ALIEN_COLS;
        const alive = allRowCells.reduce((n, cells) => n + cells.filter(c => c.alive).length, 0);
        // Linear interpolation: 6 + (alive/total) * 14  →  20 at full, 6 at empty
        topRow.stepInterval = Math.max(6, Math.round(6 + (alive / totalAliens) * 14));
      }

      // Tick active explosions and cull finished ones
      for (let i = explosions.length - 1; i >= 0; i--) {
        const exp = explosions[i];
        if (exp.timer > 0) exp.timer--;
        exp.particles.forEach(p => {
          if (p.life <= 0) return;
          p.x  += p.vx;
          p.y  += p.vy;
          p.vy += 0.06; // slight gravity pulls debris downward
          p.life--;
        });
        if (exp.timer <= 0 && exp.particles.every(p => p.life <= 0)) {
          explosions.splice(i, 1);
        }
      }
    };

    const draw = () => {
      ctx.fillStyle = '#000000';
      ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

      // ── HUD helper ──────────────────────────────────────────────────────
      const hud = (str, x, y, size = 15, color = '#FFFFFF', align = 'center') => {
        ctx.font      = `bold ${size}px "Courier New", monospace`;
        ctx.fillStyle = color;
        ctx.textAlign = align;
        ctx.fillText(str, x, y);
      };

      // ── Top score bar — original layout ─────────────────────────────────
      // Labels row
      hud('SCORE<1>',  190, 18, 13);
      hud('HI-SCORE',  CANVAS_WIDTH / 2, 18, 13);
      hud('SCORE<2>',  610, 18, 13);
      // Values row
      hud(String(score).padStart(4, '0'),   190, 36, 15);
      hud(String(hiScore).padStart(4, '0'), CANVAS_WIDTH / 2, 36, 15);
      hud('00',                              610, 36, 15);

      // Thin separator under score bar
      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(0, 44); ctx.lineTo(CANVAS_WIDTH, 44);
      ctx.stroke();

      // ── Ground line ─────────────────────────────────────────────────────
      ctx.strokeStyle = '#00FF41';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(0, CANVAS_HEIGHT - 30);
      ctx.lineTo(CANVAS_WIDTH, CANVAS_HEIGHT - 30);
      ctx.stroke();

      // ── Bottom bar: lives + credit ───────────────────────────────────────
      // Numeric life count
      hud(String(lives), 16, CANVAS_HEIGHT - 10, 15, '#FFFFFF', 'left');
      // Cannon sprites — original shows (lives - 1) icons
      const lifeIconScale = 2;
      const lifeIconW     = 13 * lifeIconScale;
      for (let i = 0; i < lives - 1; i++) {
        const ix = 30 + i * (lifeIconW + 6);
        const iy = CANVAS_HEIGHT - 26;
        ctx.fillStyle = '#00FF41';
        CANNON_SPRITE.forEach((row, ri) =>
          row.forEach((px, ci) => {
            if (px) ctx.fillRect(ix + ci * lifeIconScale, iy + ri * lifeIconScale, lifeIconScale, lifeIconScale);
          })
        );
      }
      // Credit counter — bottom-right
      hud(`CREDIT  ${String(credits).padStart(2, '0')}`, CANVAS_WIDTH - 16, CANVAS_HEIGHT - 10, 13, '#FFFFFF', 'right');

      drawBases();
      drawExplosions();
      drawAliens();
      drawPlayer();
      drawBullet();
    };

    // ── Attract / title screen ─────────────────────────────────────────────
    const drawAttractScreen = () => {
      const cx = CANVAS_WIDTH / 2;

      ctx.fillStyle = '#000000';
      ctx.fillRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

      // Helper: arcade-style monospace text
      const txt = (str, x, y, size = 18, color = '#FFFFFF', align = 'center') => {
        ctx.font      = `bold ${size}px "Courier New", monospace`;
        ctx.fillStyle = color;
        ctx.textAlign = align;
        ctx.fillText(str, x, y);
      };

      // ── Top score bar ────────────────────────────────────────────────────
      txt('SCORE<1>',  190,  36, 15);
      txt('HI-SCORE',  cx,   36, 15);
      txt('SCORE<2>',  610,  36, 15);
      txt('00',        190,  57, 15);
      txt('0000',      cx,   57, 15);
      txt('00',        610,  57, 15);

      ctx.strokeStyle = '#FFFFFF';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(0, 65); ctx.lineTo(CANVAS_WIDTH, 65);
      ctx.stroke();

      // ── GAME OVER (flashes at 2 Hz) ──────────────────────────────────────
      if (blinkOn) {
        txt('GAME  OVER', cx, 118, 36);
      }

      // ── Score advance table ───────────────────────────────────────────────
      txt('*  SCORE  ADVANCE  TABLE  *', cx, 182, 17, '#38bdf8');

      // Horizontal rule under heading
      ctx.strokeStyle = '#38bdf8';
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(cx - 200, 190); ctx.lineTo(cx + 200, 190);
      ctx.stroke();

      const drawSprite = (sprite, x, y, scale, color) => {
        ctx.fillStyle = color;
        sprite.forEach((row, ri) =>
          row.forEach((px, ci) => {
            if (px) ctx.fillRect(x + ci * scale, y + ri * scale, scale, scale);
          })
        );
      };

      const spriteX = cx - 150; // left edge of sprite column
      const textX   = cx -  60; // left edge of label column
      const tScale  = 3;

      // Mystery saucer — ? pts (drawn in red, as on original colour overlay)
      drawSprite(MYSTERY_SPRITE, spriteX - 10, 204, tScale, '#FF4444');
      txt('= ?  MYSTERY', textX, 228, 17, '#FFFFFF', 'left');

      // Squid — 30 pts
      drawSprite(SQUID_A, spriteX + 8, 254, tScale, '#FFFFFF');
      txt('= 30 POINTS',  textX, 278, 17, '#FFFFFF', 'left');

      // Crab — 20 pts
      drawSprite(CRAB_A, spriteX, 304, tScale, '#FFFFFF');
      txt('= 20 POINTS',  textX, 328, 17, '#FFFFFF', 'left');

      // Octopus — 10 pts
      drawSprite(OCTOPUS_A, spriteX - 6, 354, tScale, '#FFFFFF');
      txt('= 10 POINTS',  textX, 378, 17, '#FFFFFF', 'left');

      // ── Ground line ───────────────────────────────────────────────────────
      ctx.strokeStyle = '#00FF41';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(0, CANVAS_HEIGHT - 30); ctx.lineTo(CANVAS_WIDTH, CANVAS_HEIGHT - 30);
      ctx.stroke();

      // ── Coin / start prompts ──────────────────────────────────────────────
      if (credits === 0) {
        if (blinkOn) {
          txt('INSERT  COIN', cx, CANVAS_HEIGHT - 90, 24);
        }
        txt('PRESS  C  TO  INSERT  A  COIN', cx, CANVAS_HEIGHT - 58, 14, '#8896ac');
      } else {
        txt('PRESS  S  TO  PLAY', cx, CANVAS_HEIGHT - 90, 24, '#00FF41');
        txt('PRESS  C  TO  INSERT  A  COIN', cx, CANVAS_HEIGHT - 58, 14, '#8896ac');
      }

      // ── Credit counter (bottom-left, always visible) ──────────────────────
      txt(`CREDIT  ${String(credits).padStart(2, '0')}`, 16, CANVAS_HEIGHT - 10, 15, '#FFFFFF', 'left');
    };

    const gameLoop = () => {
      // Blink cadence: toggle every 30 frames (~0.5 s at 60 fps)
      blinkTimer++;
      if (blinkTimer >= 30) { blinkTimer = 0; blinkOn = !blinkOn; }

      if (gameState === 'attract') {
        drawAttractScreen();
      } else {
        update();
        draw();
      }
      animationFrameId = requestAnimationFrame(gameLoop);
    };

    animationFrameId = requestAnimationFrame(gameLoop);

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup',   handleKeyUp);
    };
  }, []);

  return (
    <div className="space-invaders-container">
      <div className="game-header">
        <h1 className="game-title">SPACE INVADERS</h1>
      </div>
      <div className="canvas-wrapper">
        <canvas
          ref={canvasRef}
          width={CANVAS_WIDTH}
          height={CANVAS_HEIGHT}
        />
      </div>
    </div>
  );
};

export default SpaceInvaders;
